import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=6540e109&scoped=true"
import script from "./ScrollToTop.vue?vue&type=script&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&lang=js"
import style0 from "./ScrollToTop.vue?vue&type=style&index=0&id=6540e109&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6540e109",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6540e109')) {
      api.createRecord('6540e109', component.options)
    } else {
      api.reload('6540e109', component.options)
    }
    module.hot.accept("./ScrollToTop.vue?vue&type=template&id=6540e109&scoped=true", function () {
      api.rerender('6540e109', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/footer/ScrollToTop.vue"
export default component.exports